import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

// Admin authentication dialog component
const AdminLoginDialog = ({ isOpen, onClose, onLogin, actionName }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === "admin123" || password === "moderator123") {
      const role = password === "admin123" ? "admin" : "moderator";
      localStorage.setItem("dashboard_auth", "true");
      localStorage.setItem("dashboard_role", role);
      onLogin(true, role);
      setPassword("");
      setError("");
      onClose();
    } else {
      setError("Invalid password. Try 'admin123' or 'moderator123'");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-slate-800 border-slate-700">
        <DialogHeader>
          <DialogTitle className="text-white">Authentication Required</DialogTitle>
          <DialogDescription className="text-slate-400">
            Please enter the admin or moderator password to {actionName}.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <Label htmlFor="password" className="text-slate-200">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin123 or moderator123"
              required
              className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-400"
            />
            {error && <p className="text-red-400 text-sm mt-1">{error}</p>}
          </div>
          <div className="flex justify-end space-x-2">
            <Button type="button" variant="outline" onClick={onClose} className="border-slate-600 text-slate-300 hover:bg-slate-700">
              Cancel
            </Button>
            <Button type="submit" className="bg-blue-600 hover:bg-blue-700">
              Login
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AdminLoginDialog;
